import React, { Component } from 'react';
import Parse from 'parse';
import $ from "jquery";
const BATCH_SIZE = 100;
class saveNotificationall extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          currentIndex: 0,
          data: {}, // Assuming data is an array of objects to be saved
          batchSize: 100, // Define the batch size for processing
          isUploading: false,
          uploadProgress: 0,
          isSaving: false,
          saveProgress: 0,
          isMountedFlagdata:false,
           dataBuffer: [], 
           isProcessing: false,
      }
      this.isMountedFlag = false;
        const currentUser = Parse.User.current();
        let postNotificationid=props.postNotificationid;
        let postPhotoid=props.postPhotoid;
        let postMsg=props.postMsg;
        let communityComment='';
        let comment='';
        //let currentIndex=0;
        let postActivityComment=props.postActivityComment;
        console.log('all postPhotoid');
        console.log(postPhotoid);
        console.log(postMsg);
        
        if (currentUser) { 

            if(postMsg==='created a challenge')
            {
                this.saveallnotification(postPhotoid,postMsg,'');
               // this.uploadData(postPhotoid,postMsg,'');
            }

          
      }
     
    }
     componentDidMount() { console.log('componentDidMount');
   // this.isMountedFlag = true; // Component is mounted
        this.state.isMountedFlagdata = true;
         const { buffer, currentIndex } = this.loadStateFromLocalStorage();
    this.setState({ dataBuffer: buffer, currentIndex });
    console.log('componentDidMount buffer');console.log(buffer);
    console.log('currentIndex'+currentIndex);
        
  }
 loadStateFromLocalStorage = () => {
    const buffer = localStorage.getItem('dataBuffer');
    const index = localStorage.getItem('currentIndex');
    return {
      buffer: buffer ? JSON.parse(buffer) : [],
      currentIndex: index ? parseInt(index, 10) : 0,
    };
  };
  componentWillUnmount() {
  //  this.isMountedFlag = false; // Component is unmounted
        this.state.isMountedFlagdata = false;
  }
// saveStateToLocalStorage(buffer, currentIndex) {
/*saveStateToLocalStorage = (buffer, currentIndex) => { console.log('saveStateToLocalStorage');
console.log(buffer);
console.log(currentIndex);
  localStorage.setItem('dataBuffer', JSON.stringify(buffer));
  localStorage.setItem('currentIndex', currentIndex.toString());
}*/
     saveallnotification = async (photodata,msg,comment) => {
         let currentUser = Parse.User.current(); 
        console.log('toggleNotificationAll');
         console.log(photodata);
         var self = this;
          var userquery = new Parse.Query('User');    
                            userquery.limit(999999999);  
                            userquery.notEqualTo("displayUsername", currentUser.get("displayUsername"));
                             comment="created a challenge";  
                            let communityComment=photodata.get('user').get("displayUsername")+"'s created a challenge";   
                            const records = [];  

                            try {
                                // Fetch the data from Parse API
                                const result = await userquery.find();

                                if(result)
                                {
                                   
                                               /* notificationNew.set("_wperm", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notificationNew.set("_rperm", {
                                                  "*": {
                                                   "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notificationNew.set("_acl", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });*/
                                                /*var acl = new Parse.ACL();
                                                acl.setPublicReadAccess(true);
                                                acl.setPublicWriteAccess(true);
                                                acl.setWriteAccess(currentUser, true); 
                                                acl.setReadAccess(currentUser, true); 
                                                notificationNew.setACL(acl);*/
                     
                            for (const matchusername of result) 
                                 {
                                    let NotificationN = Parse.Object.extend("Notification");
                                    let notificationNew = new NotificationN();
                                    notificationNew.set('viewed', 0);
                                    let thumbnail = photodata.get('thumbnail');
                                    let currentUser = Parse.User.current(); 
                                    let currentUser_id=currentUser.id;
                                    if(thumbnail!=undefined)
                                     { 
                                          notificationNew.set('thumbnail', thumbnail);
                                     }
                                      notificationNew.set('commentingUser', currentUser);
                                      notificationNew.set('photo', photodata);
                                      notificationNew.set('communityComment', communityComment);
                                        notificationNew.set('comment', comment);
                                        notificationNew.set('index', 0);  
                                        notificationNew.set('challenge', 1);


                                       notificationNew.set('notifiedUser', matchusername);
                                       let fromUserThumb = matchusername.get('profilePictureSmall');                       
                                        if(fromUserThumb!=undefined)
                                         { 
                                              notificationNew.set('profilePictureSmall', fromUserThumb);
                                         }
                                        
                                       // await notificationNew.save();
                                       records.push(notificationNew);               
                              
                                    }                                                       
                                    const data = records;
                                    const batchSize = 1000;
                                    const chunks = this.chunkData(records, batchSize);
                                  
                                    for (let i = 0; i < chunks.length; i++) { //console.log('length');console.log(chunks.length+'this.isMountedFlag'+this.isMountedFlag)
                                    //  if (!this.isMountedFlag) break; // Ensure component is still mounted
                                      //   if (!this.state.isMountedFlagdata) break;
                                      const success = await this.saveBatch(chunks[i]);
                                      console.log(success);
                                      if (!success) {
                                        console.error(`Failed to save batch ${i + 1}`);
                                      }
                                    //  if (this.isMountedFlag) {
                                       if (this.state.isMountedFlagdata) {  console.log('isMountedFlagdata DD'+this.state.isMountedFlagdata)
                                        this.setState({ saveProgress: ((i + 1) / chunks.length) * 1000 });
                                      }
                                    }

                                   // if (this.isMountedFlag) {
                                     if (this.state.isMountedFlagdata) {
                                      this.setState({ isSaving: false });
                                      alert('Save complete!');
                                    }

                                  }
                                } catch (error) {
                                console.error('Error fetching data from Parse:', error);
                              }
            

     };

 // Function to chunk data into smaller batches
  chunkData = (data, batchSize) => {console.log('chunkData');
    let chunks = [];
    for (let i = 0; i < data.length; i += batchSize) {
      chunks.push(data.slice(i, i + batchSize));
    }
    return chunks;
  };

  // Function to save a single batch to Parse
  saveBatch = async (batch) => {
    try {
     //  await Parse.Object.saveAll(batch);

     /*   this.setState(
        prevState => ({ currentIndex: prevState.currentIndex + BATCH_SIZE }),
        () => {
        
         localStorage.setItem('dataBuffer', JSON.stringify(batch));
         localStorage.setItem('currentIndex', this.state.currentIndex.toString());
          setTimeout(this.processInBackground, 5000); // Adjust delay as needed
        }
      );*/
     

   
     } catch (error) {
      console.error(`Error saving record:`, error);
    }
    
  };

 

    render() {
        return  '';
    }
}
export default saveNotificationall;


// WEBPACK FOOTER //
// ./src/saveNotificationall.jsx